<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-6 text-center">
        <h3 class="text-nowrap text-center">
          {{ stepMessage }}
        </h3>
        <div class="progress">
          <div
            class="progress-bar bg-success"
            role="progressbar"
            :aria-valuenow="progress"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{'width': progress + '%'}"
          >
            <span class="sr-only">{{ progress }}{{ $t('enrollmentStep.progress.percentComplete') }}</span>
          </div>
          <div
            v-if="!complete"
            class="progress-bar progress-bar-inprogress"
            role="progressbar"
            :aria-valuenow="progress"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{'width': stepPercentage + '%'}"
          />
          <div
            v-if="!complete"
            class="progress-bar progress-bar-inprogress-arrow"
            role="progressbar"
            :aria-valuenow="progress"
            aria-valuemin="0"
            aria-valuemax="100"
          />
        </div>
        <p>
          <a href="#" data-progress-modal @click.prevent="toggleModal(true)">{{ $t('enrollmentStep.progress.seeYourProgress') }}</a>
        </p>
      </div>
    </div>
    <b-modal
      :visible="showModal"
      @cancel="toggleModal(false)"
    >
      <div slot="title">
        {{ $t('enrollmentStep.progress.yourProgress') }}  <span v-if="loading" class="fa fa-sync anim-spin" />
      </div>

      <ol
        v-if="events" 
        class="list-group list-group-numbered" 
        :class="{'opacity-70' : loading}"
      >
        <li v-for="event in events" class="list-group-item" :class="[statusMap[event.status]]">
          <h3>{{ event.event.name }} <i v-if="event.status === 'completed'" class="fa fa-check" /></h3>
        </li>
      </ol>
      <h3 v-else class="text-center">
        {{ $t('enrollmentStep.progress.loading') }}
      </h3>
      
      <div slot="modal-footer">
        <button type="button" class="btn btn-primary btn-block btn-lg" @click="toggleModal(false)">
          {{ $t('enrollmentStep.progress.continueEnrollment') }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { BModal } from "bootstrap-vue";

  export default {
    components: {
      BModal,
    },
    props: {
      enrollmentState: {
        type: Object,
        required: true
      },
      studyId: {
        type: Number,
        required: true,
      },
      participantId: {
        type: Number,
        required: false
      },
    },
    data() {
      return {
        showModal: false,
        loading: false,
        events: null
      }
    },
    computed: {
      currentStep() {
        return this.enrollmentState.progress ? this.enrollmentState.progress.completedSteps + 1 : 0;
      },
      completedSteps() {
        return this.enrollmentState.progress ? this.enrollmentState.progress.completedSteps : 0;
      },
      totalSteps() {
        return this.enrollmentState.progress ? this.enrollmentState.progress.totalSteps : 0;
      },
      complete() {
        return this.completedSteps >= this.totalSteps;
      },
      stepMessage() {
        return !this.complete ? this.$t('enrollmentStep.progress.stepCount', { currentStep: this.currentStep, totalSteps: this.totalSteps }) : this.$t('enrollmentStep.progress.enrollmentComplete');
      },
      stepPercentage() {
        if (!this.enrollmentState.progress) {
          return 0;
        }
        return (1 / this.totalSteps) * 100;
      },
      progress() {
        if (!this.enrollmentState.progress) {
          return 0;
        }
        return (this.completedSteps / this.totalSteps) * 100;
      }
    },
    created() {
      // non-reactive
      this.statusMap = {
        'active': 'active',
        'completed': 'list-group-item-success',
        'future': 'disabled',
        'disabled': 'disabled'
      };
    },
    methods: {
      toggleModal(state) {
        // if opening, (re)load events 
        if (state) {
          this.loading = true;
          this.$api.FeedbackEvents.getFeedbackEvents({
            'study_id': this.studyId,
            'participant.id': this.participantId,
            'type': 'UserEnrollmentStep'
          }).then(({status, body}) => {
            if (status >= 400) {
              throw { status, body } 
            }

            this.events = body.data;
            this.loading = false;
          }).catch((err) => {
            // TODO: Sentry
            alert(this.$t('enrollmentStep.progress.refreshPage'));
          });
        }
        this.showModal = state;
      }
    }
  }
</script>

<style scoped>
.progress {
  width: 100%;
  margin-bottom: 2px;
}
.progress .progress-bar {
  margin: 0;
}

.progress .progress-bar-inprogress {
  background-color: #bbbdc0;
}
.progress .progress-bar-inprogress-arrow {
  width: 0;
  height: 0;
  border-left: 10px solid #bbbdc0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  background: transparent;
}
</style>